import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TAIntiaroData } from 'src/app/service/api/TaApiServiceProduct';
import { TaConstantsService } from 'src/app/service/web/ta-constants.service';

@Component({
  selector: 'app-wrapper-for-main-view',
  templateUrl: './wrapper-for-main-view.component.html',
  styleUrls: ['./wrapper-for-main-view.component.css']
})
export class WrapperForMainViewComponent implements OnInit {

  public typeOfFurniture = ''; // necessary variable (Important, by default empty string); it's @Input in MainViewConfiguratorComponent
  public brandLogoPath = ''; // necessary variable (Important, by default empty string); it's @Input in MainViewConfiguratorComponent
  public showPricing = true; // necessary variable (Important, by default true); it's @Input in MainViewConfiguratorComponent

  // DATA_FOR_TESTING is only example; this data should be made by TA
  // DATA_FOR_TESTING[id] --> product ID; necessary property to create Intiaro configurator;
  // DATA_FOR_TESTING[categoryName] --> optional property;
  // DATA_FOR_TESTING[brandLogo] --> optional property (path or URL);
  // DATA_FOR_TESTING[disablePrice] --> optional property; value true lets start price-requests to the server and implement price in the DOM (value false blocks requests and removes price from the DOM)

  constructor(private route: ActivatedRoute, public taConstants: TaConstantsService) {
    // example of using 'id' parameter from routing to define properties that are @Input() decorators in MainViewConfiguratorComponent
    const idFromUrl = this.route.snapshot.paramMap.get('id');
    const data = localStorage.getItem("intiaroData");
    if (data) {
      const jsonData = JSON.parse(data) as TAIntiaroData[];
      jsonData.filter(element => {
        if (element.id == idFromUrl) {
          !!element.product_name ? this.typeOfFurniture = element.product_name : '';
          // element.disablePrice ? this.showPricing = false : '';
        }
      })
    }

  }

  ngOnInit(): void {
  }

}
